import { defa } from 'defa-object';
/**
 * defa.models.Notification
 * A description.
 * @version 0.1
 */
import Model    from 'scripts/poppet/model';

const Notification = Model.extend( {
	defaults: {
		id            : '',
		type          : '',
		category      : 'Category', // set to empty string when backend yields category. "WarmUp", "Security"...
		title         : '',
		timestamp     : '',
		description   : '',
		body          : '',
		headline      : '',
		emergencyLevel: false,
		iconTag       : '',
		createdDate   : '2000-01-01T00:00:00Z',
		read          : false
	},
	
	urlRoot: defa.vars.apiHost + '/notifications',
	
	/**
	 * Saves the 'read' attribute based input from user
	 * @param  {Boolean} read  The input value
	 */
	markAsReadCheck(read){
		return this.save( { 'read': read }, { patch: true } );
	},
	
	/**
	 * Saves the 'read' attribute as true
	 * @param  {Boolean} read  The input value
	 */
	markAsReadSwipe() {
		return this.save( { 'read': true }, { patch: true } );
	}
} );

export default Notification;